import { createContext } from "react";
import { LoadingContextInterface } from "@/types/contextTypes";

export const LoadingContext = createContext<LoadingContextInterface>({
  isLoading: false,
  startLoading: () => {},
  stopLoading: () => {},
} as LoadingContextInterface);
